import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Button, Select, TextField, Tooltip, InputAdornment, Input, Paper, Grid, OutlinedInput, Badge, Typography, FormControl, InputLabel, IconButton } from '@material-ui/core';
import { AttachFile, AddBox, DeleteOutlineOutlined as DeleteIcon, History as HistoryIcon }from '@material-ui/icons';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import ManifestStyles from './manifest.module.css';
import commonStyles from '../../common/common.module.css';
import addIcon from '../../../assets/add.svg';

import OfflineRfs, { CurrentAwb } from '../../../models/OfflineRfs';
import Awb from '../../../models/Awb';

//Table imports
import MaterialTable from 'material-table';
import tableIcons from '../../../utils/editTableIcons';

interface rowAwb {
  id: number;
  awb: string;
  destination: string;
  number: string;
  origin: string;
  pieces: string;
  weight: string;
  org: string;
  dst: string;
  special: string;
  returned: boolean;
};

const styles = (theme: Theme) =>

  createStyles({
    rfsPaper: {
      padding: '24px 32px',
      marginTop: '24px',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
      backgroundColor: 'var(--greybkg)',
      width: '100%',
      marginBottom: '30px'
    },
    sectionTitle: {
      color: 'var(--primaryblue)',
      fontWeight: 600,
      fontSize: '18px',
      marginBottom: '20px',
      borderBottom: '1px solid #eee',
      paddingBottom: '10px'
    },
    wrapperwithborder: {
      display: 'flex',
      marginTop: '10px',
      marginBottom: 'var(--m-wrapper)',
      flexWrap: 'wrap',
    },
    wrapper: {
      display: 'flex',
      marginBottom: '0',
      marginRight: '-20px',
      marginLeft: 'auto',
      flexWrap: 'wrap',
      color: '#003261',
    },
    hr: {
      display: 'block',
      height: '1px',
      border: '0',
      borderTop: '1px solid #ccc',
      margin: '1em 0',
      padding: '0',
      marginBottom: '30px',
    },
    hyphenspan:{
      background:'#fff', 
      padding: '0 10px', 
    },
    textspan:{
      width: '100%',
      textAlign: 'center',
      borderBottom: '1px solid #000',
      lineHeight: '0.1em',
      margin: '10px 0 20px',
    },
    toUpperCase: {
      textTransform:'uppercase'
    },
    disabledIcon: {
      '& svg': {
        color: 'rgb(204, 204, 204)',
      }
    },
    searchIcon: {
      '& svg': {
      color: 'var(--primaryblue)'
      }
    },
    tablewrapper: {
      display: 'flex',
      marginTop: '20px',
      marginBottom: '10px',
      justifyContent: 'space-between',
      maxWidth: '1300px',
      marginRight: 'auto',
      marginLeft: 'auto',

    },
    flexAndRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    awbNumber: {
      '& > div::before' : {
        border: 'none'
      },
    },
    awbActionsList: {
      display: 'flex',
      flexDirection: 'row',
      width: '95%',
      justifyContent: 'space-around',
    },
    actionMaterialIcon: {
      color: '#000',
      fontSize: '20px',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    awbWrap: {
      display: 'flex',
      border: 'none !important',
      position: 'relative',
      '& svg': {
        fontSize: '20px'
      }
    },
    button: {
      height:' 100%',
      padding: 0,
      paddingRight: '0px',
      position: 'absolute',
      right: '0px',
      top: '0px',
      bottom: '0px',
      maxHeight: '26px',
      minWidth: '26px',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
    materialIcon: {
      fontSize: 38,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    label: {
      fontSize: '11px',
      color: 'var(--primaryblue)',
      fontWeight: 600,
      paddingLeft: '12px'
      },
    buttonWrapper: {
      display: 'flex',
      alignItems: 'flex-end'
    },
    inputsWrapper: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },

    equipmentSelect: {
      fontSize: '13px',
    },
    endAdornment: { 
      width: '50%',
      fontSize: '2rem',
      maxHeight: 'max-content',
      height: 'fit-content',
      margin: '0',
      '& p': {
        color: 'black'
      }
    },
    red: {
      color: 'red',
      cursor: 'pointer',
      fontSize: '20px'
    },
    w100: {
      width: '100%'
    },
    wtWidth: {
      width: '11.85%',
    }
  });

interface ManifestSetupProps {
  classes: any;
  handleClick: (name: string, type: boolean) => void;
  offlineRfs: OfflineRfs;
  awbValue: string;
  isDisabled: Function;
  searchAwb: any;
  handleChange: (type: string, event: any) => void;
  awb: Awb;
  addAwb: Function;
  currentAwb: CurrentAwb;
  offlineAwbs: any;
  openAttachments: (awb: string) => void;
  deleteAwb: (id: number) => void;
  setState: Function;
  onClick?: (event: any) => void;
  printAwbInfoClicked: (awb: string, version: number) => void;
  manualEntry: boolean;
  openShipmentHistory: Function;
  specialsOptions: string[];
};

const manifestSetup = (props: ManifestSetupProps) => {

  const { classes, offlineRfs } = props;
  const specialOptions: Array<JSX.Element> = props.specialsOptions.map((item: string, index: number) => {
    return <option key={ index } value={ item }>{ item }</option>
  });
  let scheduleDate: string = '';
  let scheduleTimeFormated: string = '';
  let scheduleArrDate: string = '';
  let scheduleArrTimeFormated: string = '';
  let daysDifference: number = 0;
  let hours: number = 0;
  let inMinutes: string = '';
  if(offlineRfs && offlineRfs.scheduleDate && offlineRfs.scheduleArrDate && offlineRfs.scheduleTime && offlineRfs.scheduleArrTime) {
    scheduleDate = moment(offlineRfs.scheduleDate).format('DDMMMYYYY').toUpperCase();
    scheduleTimeFormated = moment(offlineRfs.scheduleTime).format('HH:mm');
    scheduleArrDate = moment(offlineRfs.scheduleArrDate).format('DDMMMYYYY').toUpperCase()
    scheduleArrTimeFormated = moment(offlineRfs.scheduleArrTime).format('HH:mm');
    daysDifference = moment(offlineRfs.scheduleArrDate).diff(moment(offlineRfs.scheduleDate), 'days');
    var startTime = moment(offlineRfs.scheduleTime);
    var endTime = moment(offlineRfs.scheduleArrTime);
    hours = endTime.diff(startTime, 'hours');
    inMinutes = moment.utc(moment(endTime, "HH:mm:ss").diff(moment(startTime, "HH:mm:ss"))).format("mm");
  }

  return (
    <div>
      {offlineRfs && Object.keys(offlineRfs).length > 0 && (
        <div className={ commonStyles.wrapper }>
          <h3 className={ commonStyles.header }>Manifest Details</h3> 
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={2} lg>
              <TextField
                id="rfsNumber"
                value={ offlineRfs.rfsNumber }
                variant="outlined"
                disabled
                fullWidth
                className={commonStyles.customTextField}
                InputProps={{ classes: { notchedOutline: commonStyles.noNotch },}}
                InputLabelProps={{ 
                  shrink: true,
                  className: commonStyles.customLabelProp
                }}
                label="RFS Number"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <TextField
                id="pickUpDetails"
                value={ `${offlineRfs.org}-${offlineRfs.pickUpName}` }
                variant="outlined"
                disabled
                fullWidth
                className={commonStyles.customTextField}
                InputProps={{ classes: { notchedOutline: commonStyles.noNotch },}}
                InputLabelProps={{ 
                  shrink: true,
                  className: commonStyles.customLabelProp
                }}
                label="PickUp Details"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <TextField
                id="dropOffDetails"
                value={ `${offlineRfs.dst}-${offlineRfs.dropOffName}` }
                variant="outlined"
                disabled
                fullWidth
                className={commonStyles.customTextField}
                InputProps={{ classes: { notchedOutline: commonStyles.noNotch },}}
                InputLabelProps={{ 
                  shrink: true,
                  className: commonStyles.customLabelProp
                }}
                label="Dropoff Details"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2}>
              <TextField
                id="scheduleDeparture"
                value={ `${scheduleDate} ${scheduleTimeFormated}` }
                variant="outlined"
                disabled
                fullWidth
                className={commonStyles.customTextField}
                InputProps={{ classes: { notchedOutline: commonStyles.noNotch },}}
                InputLabelProps={{ 
                  shrink: true,
                  className: commonStyles.customLabelProp
                }}
                label="Scheduled Departure"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2}>
              <TextField
                id="scheduleArrival"
                value={ `${scheduleArrDate} ${scheduleArrTimeFormated}` }
                variant="outlined"
                disabled
                fullWidth
                className={commonStyles.customTextField}
                InputProps={{ classes: { notchedOutline: commonStyles.noNotch },}}
                InputLabelProps={{ 
                  shrink: true,
                  className: commonStyles.customLabelProp
                }}
                label="Scheduled Arrival"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg>
              <TextField
                id="duration"
                value={ `${daysDifference > 0 ? daysDifference + 'd ' : ''}${hours}h ${inMinutes}m` }
                variant="outlined"
                disabled
                fullWidth
                className={commonStyles.customTextField}
                InputProps={{ classes: { notchedOutline: commonStyles.noNotch },}}
                InputLabelProps={{ 
                  shrink: true,
                  className: commonStyles.customLabelProp
                }}
                label="Total Duration"
              />
            </Grid>
          </Grid>
        </div>
      )}

      <div className={ commonStyles.wrapper }>
        <h3 className={ commonStyles.header }>Add Airwaybills to Manifest</h3> 

        <Grid container spacing={3} alignItems="center">
          
          <Grid item xs={12} sm={12} md={3} lg={2}>
              <TextField
                  placeholder="Airwaybill Number"
                  id="awbNumber"
                  value={ props.awbValue }
                  onChange={ (event) => props.handleChange('awbNumber', event) }
                  variant= "outlined"
                  fullWidth
                  onKeyDown={ props.searchAwb }
                  InputProps={{
                    classes: { notchedOutline: commonStyles.noNotch },
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon 
                            onClick={ !props.isDisabled() ? props.searchAwb : undefined } 
                            style={{ cursor: !props.isDisabled() ? 'pointer' : 'default', color: !props.isDisabled() ? 'var(--primaryblue)' : '#ccc' }}
                          />
                        </InputAdornment>
                      )
                  }}
                  className={commonStyles.customTextField}
                  InputLabelProps={{ 
                    shrink: true,
                    className: commonStyles.customLabelProp
                  }}
                  label="Search"
              />
          </Grid>

          <Grid item xs={12} sm={6} md={2} lg={1}>
            <TextField
              id="origin"
              placeholder="Origin"
              value={ props.currentAwb.org || '' }
              onChange={ (event) => props.handleChange('org', event) }
              variant="outlined"
              disabled={ !props.manualEntry }
              fullWidth
              inputProps={{ 
                // classes: { notchedOutline: commonStyles.noNotch },
                style: { textTransform: 'uppercase' }}} 
                className={`${commonStyles.customTextField} ${commonStyles.noNotch}`}
                  InputLabelProps={{ 
                    shrink: true,
                    className: commonStyles.customLabelProp
                  }}
                  label="Origin"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2} lg={1}>
            <TextField
              id="destination"
              placeholder="Dest"
              value={ props.currentAwb.dst || '' }
              onChange={ (event) => props.handleChange('dst', event) }
              variant="outlined"
              disabled={ !props.manualEntry }
              fullWidth
              inputProps={{ style: { textTransform: 'uppercase' } }}
              className={`${commonStyles.customTextField} ${commonStyles.noNotch}`}
              InputLabelProps={{ 
                shrink: true,
                className: commonStyles.customLabelProp
              }}
              label="Destination"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={2} lg={1}>
            <TextField
              id="pcs"
              placeholder="Pcs"
              value={ props.currentAwb.pieces || '' }
              onChange={ (event) => props.handleChange('pieces', event) }
              onFocus={ () => props.handleClick('pieces', true) }
              onBlur={ () => props.handleClick('pieces', false)  }
              variant="outlined"
              InputProps= {{
                endAdornment: props.currentAwb.focused ? <InputAdornment position="end">{' / '+props.awb.pieces}</InputAdornment> : null,
                classes: { notchedOutline: commonStyles.noNotch },
              }}
              disabled={ !props.manualEntry }
              fullWidth
              className={commonStyles.customTextField}
              InputLabelProps={{ 
                shrink: true,
                className: commonStyles.customLabelProp
              }}
              label="Pcs"
            />
          </Grid>

          <Grid item xs sm md={2} lg={1}>
            <TextField
              id="weight"
              value={ props.currentAwb.weight || '' }
              placeholder="Wgt"
              onChange={ (event) => props.handleChange('weight', event) }
              onFocus={ () => props.handleClick('weight', true) }
              onBlur={ () => props.handleClick('weight', false) }
              variant="outlined"
              InputProps= {{
              endAdornment: props.currentAwb.wghFocused ? <InputAdornment position="end">{' / '+props.awb.weight}</InputAdornment> : null,
              classes: { notchedOutline: commonStyles.noNotch },
              }}
              disabled={ !props.manualEntry }
              fullWidth
              className={commonStyles.customTextField}
              InputLabelProps={{ 
                shrink: true,
                className: commonStyles.customLabelProp
              }}
              label="Weight"
            />
          </Grid>

          <Grid item xs={'auto'} classes={{ root: ManifestStyles.historyGridRoot }} className={ ManifestStyles.historyGrid } >
            <Button 
              color="primary" 
              size="small" 
              disabled={ !props.currentAwb.pieces } 
              onClick={(event) => props.openShipmentHistory()} 
              className={ManifestStyles.historyButton}
              classes={{ root: ManifestStyles.historyButtonRoot,
                label: ManifestStyles.historyButtonLabel
              }}
            >
                H
            </Button>
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg={2}>
            <FormControl variant="outlined" fullWidth className={commonStyles.customTextField}>
              <InputLabel shrink className={commonStyles.customLabelProp}>Specials</InputLabel>
              <Select
                native
                label="Specials"
                onChange={ (event) => props.handleChange('special', event) }
                value={ props.currentAwb.special ? props.currentAwb.special : -1 }
                inputProps={{
                  name: 'special',
                  id: 'specials-select',
                  placeholder: 'Specials'
                }}
                className={commonStyles.noNotch}
              >
                <option value={-1}>Specials</option>
                { specialOptions }
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs sm md={4} lg>
            <TextField
              id="remarks"
              placeholder="Remarks"
              value={ props.currentAwb.remarks }
              onChange={ (event) => props.handleChange('remarks', event) }
              variant="outlined"
              fullWidth
              className={commonStyles.customTextField}
              InputProps={{ classes: { notchedOutline: commonStyles.noNotch },}}
              InputLabelProps={{ 
                shrink: true,
                className: commonStyles.customLabelProp
              }}
              label="Remarks"
            />
          </Grid>

          <Grid item xs={'auto'}>
            <IconButton
              onClick={(event) => props.addAwb()}
              size="small"
              title="Add Awb"
              className={ManifestStyles.addButton}
              classes={{ root: ManifestStyles.addButtonRoot }}
            >
              <img alt="add" src={addIcon} width={24} 
              />
            </IconButton>
          </Grid>
        </Grid>
      </div>

      <div className={ commonStyles.wrapper}>

        <h3 className={commonStyles.header}>Airwaybill </h3> 
        <MaterialTable
          components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
          icons={tableIcons}
          data={props.offlineAwbs}
          columns={[
            {
              title: 'Airwaybill', field: '', cellStyle: { width: '120px' },
              render: (rowData: any) => {
                return <span>{rowData.awb}</span>;
              }
            },
            { title: 'Origin', field: 'org', editable: 'never'  },
            { title: 'Dest', field: 'dst', editable: 'never' },
            { title: 'Pcs', field: 'pieces'},
            {
              title: 'Weight', field: 'weight',
              render: (rowData: any) => {
                return `${rowData.weight}K`;
              }
            },
            { title: 'Specials', field: 'special',
            editComponent: (editComponentProps: any) => {

              return (<Select native
                value={editComponentProps.value || ''}
                onChange={ e => {
                  editComponentProps.onChange(e.target.value);
                } }
                className={classes.selectStatusStyle}>
                  <option value={-1} />
                  { specialOptions }
              </Select>);
            } },
            { title: 'Remarks', field: 'remarks' },
          ]}

          actions = {[
            (rowData: any) => ({
              icon: () =>   <span>
              <Badge className={ `${commonStyles.attachmentBadge}` } color="secondary" badgeContent={ rowData.attachment_count }>
                <AttachFile className={classes.actionMaterialIcon} />     
                </Badge>
            </span>,
              tooltip: 'Attach file',
              onClick: (event, rowData: rowAwb | rowAwb[]) => {
                if (!Array.isArray(rowData)) {
                  props.openAttachments(rowData.awb);
                }
              }
            }),
            (rowData: any) => ({
              icon: () => <DeleteIcon className={classes.actionMaterialIcon} />,
              tooltip: 'Delete from list',
              onClick: (event, rowData: rowAwb | rowAwb[]) => {
                if (!Array.isArray(rowData)) {
                  props.deleteAwb(rowData.id);
                }
              }
            })
          ]}

          editable = { {
            onRowUpdate: (newData, oldData) =>
              new Promise<void>((resolve, reject) => {

                setTimeout(() => {
                  {
                    const po = props.offlineAwbs;

                    var index = po.map(function(e: any) { return e.awb; }).indexOf(newData.awb);

                    po[index] = newData;

                    props.setState({ offlineAwbs: po, }, () => resolve()); 
                  }
                  
                  resolve();
                }, 1000);
            })
          } }

          options={{
            search: false,
            paging: false,
            showTitle: false,
            actionsColumnIndex: -1,
            toolbar: false,
            sorting: false,
            headerStyle: {
              backgroundColor: 'var(--tbl_head_bkg)',
              color: 'var(--tbl_head_color)',
              zIndex: 2,
            },
          }}
        />
      </div>
    </div>
  )
};

export default withStyles(styles)(manifestSetup);